import {DisplayObjectClipSource} from "./DisplayObjectClipSource";
import {GoodgameBitmapEngine} from "../../GoodgameBitmapEngine";
import {IExternalClipSource} from "../IExternalClipSource";
import {ClipColor} from "../../components/ClipColor";
import {Signal} from "signals.js";
import {LoadingItem} from "../../../loader/LoadingItem";

import BitmapData = createjs.BitmapData;
import Event = createjs.Event;
import Point = createjs.Point;
import Rectangle = createjs.Rectangle;
import LoaderContext = createjs.LoaderContext;
import {getDefinitionByNameFromLibrary} from "@goodgamestudios/createjs-utilities";
import {BasicModel, BulkLoader} from "../../../../../index";


export class ExternalDisplayObjectClipSource extends DisplayObjectClipSource implements IExternalClipSource {
    public static surpressWarnings: boolean = false;

    protected animData: any[] = [];

    /** path of the external .swf file */
    protected _sourcePath: string;
    /** is true when the source is loaded */
    protected _isLoaded: boolean = false;

    /** is true when the source is loaded */
    public get isLoaded(): boolean {
        return this._isLoaded;
    }

    /** signal that actual loading queue is finished for the first time. name of this loader will be a parameter*/
    protected _clipLoadedAndConverted: Signal = new Signal();

    /** signal that actual loading queue is finished for the first time. name of this loader will be a parameter*/
    public get clipLoadedAndConverted(): Signal {
        return this._clipLoadedAndConverted;
    }

    /**
     * init this source. loads an external .swf and converts it when it finished loading or already loaded
     *
     * @param swfSourcePath
     * @param className of the DiaplayObject in the .swf file
     * @param color used for debug informations
     * @param priority An int that controls which items are loaded first. Items with a higher PRIORITY will load first. If more than one item has the same PRIORITY number, the order in which they are added will be taken into consideration. Checked when adding a new item to load.
     */
    public initExternalClipSource(clipClassName: string, swfSourcePath: string, colorData: ClipColor[] = null, debugColor: number = 0, hasSubLayer: boolean = false, priority: number = 1): void {
        this._sourcePath = swfSourcePath;
        this.sourceClassName = clipClassName;
        this._colorData = colorData;
        this.debugColor = debugColor;
        this.hasSubLayer = hasSubLayer;
        this._isLoaded = false;

        // the assetId should be the same like the generated file name
        let assetId = swfSourcePath.substring(swfSourcePath.lastIndexOf("/") + 1, swfSourcePath.length);
        let loaderObject: LoadingItem = GoodgameBitmapEngine.bulkLoader.addAssetBundle(this._sourcePath, {
            id: assetId.replace(/--\d+/, ""), // remove version for id
            priority: priority
        });

        if (loaderObject) {
            if (loaderObject.isLoaded) {
                this.onLoaded(null);
            }
            else {
                loaderObject.addEventListener(Event.COMPLETE, this.bindFunction(this.onLoaded));
            }
        }
    }

    /**
     * converts the DisplayObject when it finished loading or already loaded
     *
     */
    protected onLoaded(event: Event = null): void {
        if (event != null) {
            event.target.removeEventListener(Event.COMPLETE, this.bindFunction(this.onLoaded));
        }
        this._isLoaded = true;

        this.sourceClass = getDefinitionByNameFromLibrary(this.sourceClassName);
        if ( this.sourceClass ) {
            this.convertClass(this.sourceClass, this._colorData, this.debugColor, this.hasSubLayer);
            this._clipLoadedAndConverted.dispatch(this);
        }
    }
}
